// =============================================================================
// VENDOR LIST COLUMN DEFINITIONS
// =============================================================================

export type ColumnSize = "xs" | "s" | "m" | "l" | "xl";

export const COLUMN_SIZES: Record<ColumnSize, string> = {
    xs: "4rem",
    s: "6rem",
    m: "8rem",
    l: "10rem",
    xl: "12rem",
};

export interface VendorListColumnDefinition {
    field: string;
    header: string;
    sortable: boolean;
    visible: boolean;
    size: ColumnSize;
}

export function getColumnWidth(size: ColumnSize): string {
    return COLUMN_SIZES[size];
}

const I18N_PREFIX = "VENDOR_LIST.";

export const VENDOR_LIST_COLUMNS: VendorListColumnDefinition[] = [
    { field: "vendorName", header: I18N_PREFIX + "VENDOR_NAME", sortable: true, visible: true, size: "l" },
    { field: "vendorCode", header: I18N_PREFIX + "VENDOR_CODE", sortable: true, visible: true, size: "m" },
    { field: "name", header: I18N_PREFIX + "BRAND_NAME", sortable: true, visible: true, size: "l" },
    { field: "code", header: I18N_PREFIX + "BRAND_CODE", sortable: true, visible: true, size: "m" },
    { field: "discountPercent", header: I18N_PREFIX + "DISCOUNT", sortable: false, visible: true, size: "s" },
    { field: "shipmentMethodDescription", header: I18N_PREFIX + "SHIPMENT_METHOD", sortable: true, visible: true, size: "l" },
    { field: "paymentTermDescription", header: I18N_PREFIX + "PAYMENT_TERM", sortable: true, visible: true, size: "l" },
    { field: "vendorSignedAgreement", header: I18N_PREFIX + "SIGNED_AGREEMENT", sortable: true, visible: true, size: "s" },
    { field: "incVAT", header: I18N_PREFIX + "INC_VAT", sortable: false, visible: true, size: "s" },
    { field: "currency", header: I18N_PREFIX + "CURRENCY", sortable: false, visible: true, size: "s" },
];

export const DEFAULT_VENDOR_LIST_VISIBLE_COLUMNS: string[] = VENDOR_LIST_COLUMNS
    .filter(col => col.visible)
    .map(col => col.field);
